function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (theme, _ref) {
  var getColor = _ref.getColor;
  return {
    getCSS: function getCSS(_ref2) {
      var color = _ref2.color,
          fullWidth = _ref2.fullWidth,
          __internal__focus = _ref2.__internal__focus;
      var focusStyle = {
        outline: 0,
        borderRadius: theme.radii[0],
        boxShadow: theme.shadows.focus
      };
      return _objectSpread({
        display: "inline-block",
        fontSize: theme.fontSizes[1],
        fontWeight: theme.fontWeights.light,
        lineHeight: theme.lineHeights[2],
        fontFamily: theme.fonts.body,
        color: theme.colors.black,
        width: fullWidth ? "100%" : null,
        height: "48px",
        paddingLeft: theme.space[4],
        paddingRight: theme.space[10],
        margin: 0,
        border: 0,
        borderRadius: 0,
        appearance: "none",
        backgroundColor: getColor(color),
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' role='img' aria-label='Triangle down'%3E%3Cpath d='M20.747 14.509l-4.181 4.25a.786.786 0 01-1.132 0l-4.179-4.247a.885.885 0 01-.231-.827c.07-.3.287-.536.569-.62.282-.084 8.607-.101 8.912.035a.86.86 0 01.495.802.874.874 0 01-.253.607z' fill='%23000'%3E%3C/path%3E%3C/svg%3E\")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right ".concat(theme.space[4], " top 50%"),
        alignSelf: "flex-start",
        // See: https://stackoverflow.com/a/19451423/247243
        ":-moz-focusring": {
          color: "transparent",
          textShadow: "0 0 0 #000"
        },
        ":focus": focusStyle
      }, __internal__focus && focusStyle);
    }
  };
});